import React from "react";
import { motion } from "framer-motion";
import { Section } from "@/components/UI";
import { MapleLogo } from "@/components/Logo";

const VARIANTS = {
  ivory: { wrap: "bg-ccpm-ivory", text: "text-ccpm-charcoal", accent: "text-ccpm-olive", rule: "bg-ccpm-olive/40", mark: false },
  stone: { wrap: "bg-ccpm-stone", text: "text-ccpm-charcoal", accent: "text-ccpm-olive", rule: "bg-ccpm-olive/40", mark: false },
  olive: { wrap: "bg-ccpm-olive grain text-ccpm-ivory", text: "text-ccpm-ivory", accent: "text-ccpm-olive-soft", rule: "bg-ccpm-ivory/50", mark: true },
  charcoal: { wrap: "bg-ccpm-charcoal grain text-ccpm-ivory", text: "text-ccpm-ivory", accent: "text-ccpm-olive-soft", rule: "bg-ccpm-ivory/40", mark: true },
};

// Subtle, editorial brand-slogan band. Understated typography, generous whitespace,
// a hairline rule and (on dark variants) a faint maple watermark.
export function Slogan({ quote, emphasis, variant = "ivory", caps = false, testId }) {
  const v = VARIANTS[variant] || VARIANTS.ivory;
  return (
    <div className={`relative overflow-hidden ${v.wrap}`} data-testid={testId}>
      {v.mark && (
        <div className="pointer-events-none absolute -right-16 top-1/2 -translate-y-1/2 opacity-[0.06]" aria-hidden="true">
          <MapleLogo light size={320} />
        </div>
      )}
      <Section className="py-20 lg:py-28">
        <div className="relative max-w-4xl">
          <div className={`h-px w-14 ${v.rule} mb-8`} />
          <motion.blockquote
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className={`font-serif ${v.text} ${
              caps
                ? "uppercase text-xl sm:text-2xl lg:text-[2.1rem] tracking-[0.06em] leading-[1.3]"
                : "text-2xl sm:text-3xl lg:text-[2.5rem] tracking-tight leading-[1.2]"
            }`}
          >
            {quote}
            {emphasis && (
              <span className={`italic ${v.accent} ${caps ? "" : "block sm:inline"} mt-1 sm:mt-0`}> {emphasis}</span>
            )}
          </motion.blockquote>
        </div>
      </Section>
    </div>
  );
}
